import { getBlob } from "../Services/ApiBase";
import { API_ENDPOINTS } from "../Services/ApiEndPoints";
import { getApiErrorMessage } from "./apiErrorMessage";

export function parseFilenameFromContentDisposition(header) {
  if (!header || typeof header !== "string") return null;
  const utf8 = /filename\*=UTF-8''([^;\s]+)/i.exec(header);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch {
      return null;
    }
  }
  const quoted = /filename="([^"]+)"/i.exec(header);
  if (quoted) return quoted[1].trim();
  const plain = /filename=([^;\s]+)/i.exec(header);
  return plain ? plain[1].trim().replace(/^["']|["']$/g, "") : null;
}

export async function blobToErrorMessage(blob) {
  try {
    const text = await blob.text();
    const j = JSON.parse(text);
    return j.message || j.error || j.data?.message || text || "Export failed";
  } catch {
    return "Export failed";
  }
}

/**
 * GET /clients/export?format=csv|xlsx and save the file — exports all clients with their data.
 *
 * @param {"csv"|"xlsx"} [format]
 */
export async function downloadClientsExport(format = "csv") {
  const fmt = format === "xlsx" ? "xlsx" : "csv";

  try {
    const response = await getBlob(API_ENDPOINTS.CLIENTS.EXPORT, { format: fmt });

    const blob = response.data;
    const contentType = String(
      response.headers?.["content-type"] || response.headers?.["Content-Type"] || ""
    );

    if (contentType.includes("application/json")) {
      throw new Error(await blobToErrorMessage(blob));
    }

    const fallback = `clients-export.${fmt}`;
    const cd =
      response.headers?.["content-disposition"] || response.headers?.["Content-Disposition"];
    const filename = parseFilenameFromContentDisposition(cd) || fallback;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    if (err === "Request canceled") throw err;
    const data = err?.response?.data;
    if (data instanceof Blob) {
      const msg = await blobToErrorMessage(data);
      throw new Error(msg, { cause: err });
    }
    throw new Error(getApiErrorMessage(err, "Export failed"), { cause: err });
  }
}
